document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-custom-order-prefill]');
  if (!link) return;

  try {
    sessionStorage.setItem('customOrderProduct', link.dataset.customOrderPrefill);
  } catch {
    // Storage can be disabled; navigation should still work.
  }
});

const customOrderSource = document.querySelector('[data-custom-order-source]');
const floatingCustomOrder = document.querySelector('[data-custom-order-floating]');
const mobileCtaStack = document.querySelector('.product__mobile-cta-stack');

if (customOrderSource && floatingCustomOrder) {
  const stickyHeader = document.querySelector('sticky-header');
  const mobileViewport = window.matchMedia('(max-width: 749px)');
  const visualViewport = window.visualViewport;
  const revealDelay = Number.parseFloat(floatingCustomOrder.dataset.customOrderRevealDelay) || 0;
  const topOffset = Number.parseFloat(floatingCustomOrder.dataset.customOrderTopOffset) || 0;
  let mobileCtaFrame = null;

  const updateMobileCtaViewport = () => {
    mobileCtaFrame = null;

    if (!mobileCtaStack || !mobileViewport.matches || !visualViewport) {
      mobileCtaStack?.style.removeProperty('--mobile-cta-viewport-bottom');
      return;
    }

    const visualViewportBottom = visualViewport.offsetTop + visualViewport.height;
    mobileCtaStack.style.setProperty('--mobile-cta-viewport-bottom', `${visualViewportBottom}px`);
  };

  const syncMobileCtaViewport = () => {
    if (mobileCtaFrame !== null) return;
    mobileCtaFrame = window.requestAnimationFrame(updateMobileCtaViewport);
  };

  const syncFloatingCustomOrder = () => {
    if (mobileViewport.matches) {
      floatingCustomOrder.hidden = false;
      return;
    }

    const headerBottom = stickyHeader?.getBoundingClientRect().bottom || 0;
    const floatingTop = headerBottom + topOffset;

    floatingCustomOrder.style.setProperty('--custom-order-floating-top', `${floatingTop}px`);

    floatingCustomOrder.hidden =
      window.scrollY <= 0 || customOrderSource.getBoundingClientRect().bottom > floatingTop - revealDelay;
  };

  syncFloatingCustomOrder();
  syncMobileCtaViewport();
  window.addEventListener('scroll', syncFloatingCustomOrder, { passive: true });
  window.addEventListener('resize', syncFloatingCustomOrder);
  window.addEventListener('resize', syncMobileCtaViewport);
  visualViewport?.addEventListener('scroll', syncMobileCtaViewport, { passive: true });
  visualViewport?.addEventListener('resize', syncMobileCtaViewport);
}
